import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {CustomerCareService} from '@api/customer-care.service';
import {SmartDoorSchedule} from '@model/product/smart-door/schedule/smart-door-schedule.model';
import {OverrideSchedule} from '@model/product/smart-door/schedule/smart-door-override-schedule.model';

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.scss']
})
export class ScheduleComponent implements OnInit, OnChanges {

  @Input()
  schedules: Array<SmartDoorSchedule>;

  @Input()
  overrideSchedule: OverrideSchedule;

  petsInSchedules: Map<string, Array<any>> = new Map<string, Array<any>>();
  constructor(private customerCareService: CustomerCareService) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.schedules != null) {
      for (const sc of this.schedules) {
        this.customerCareService.getPetsByPetIds(sc.petIds).subscribe(
          (value) => this.petsInSchedules.set(sc.scheduleId, value.data.map(pet => pet.profile.name))
        );
      }
    }
    if (this.overrideSchedule) {
      // console.log(this.overrideSchedule);
    }
  }

  getPetNames(scheduleId: string): Array<string> {
    return this.petsInSchedules.get(scheduleId);
  }

  accessMode(access: number): string {
    switch (access) {
      case 0:
        return 'No Access';
      case 1:
        return 'Out-only';
      case 2:
        return 'In-only';
      case 3:
        return 'Full Access';
      default:
        return 'UNDEFINED';
    }
  }
}
